/**
 * @file Shared React component — components/Layout/DashboardHeader.tsx.
 */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./DashboardHeader.css";
import ConfirmModal from "../common/ConfirmModal";

const DashboardHeader: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const performLogout = () => {
    const storedSource = localStorage.getItem("loginSource");
    const derivedSource =
      user?.role === "EXPERT" || user?.role === "REVIEWER"
        ? "expert"
        : user?.role === "ADMIN" || user?.role === "SUPER_ADMIN"
        ? "admin"
        : "standard";

    const source = storedSource ?? derivedSource;
    const redirectPath =
      source === "expert" ? "/expert/login" : source === "admin" ? "/admin/login" : "/login";

    logout();
    navigate(redirectPath, { replace: true });
  };

  const handleLogoutClick = () => {
    setShowLogoutConfirm(true);
  };

  const handleCancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  const handleConfirmLogout = () => {
    setShowLogoutConfirm(false);
    performLogout();
  };

  return (
    <header className="dashboard-header">
      <div className="dashboard-header-text">
        <h1>ICoMEC</h1>
        <p>Indian Construction Materials Embodied Carbon Data Base</p>
      </div>
      <button className="logout-btn" onClick={handleLogoutClick}>
        <span className="logout-btn__icon" aria-hidden="true">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M13.25 5H6.5C5.11929 5 4 6.11929 4 7.5V16.5C4 17.8807 5.11929 19 6.5 19H13.25"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.75 12H20"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.5 8.75L20.75 13L16.5 17.25"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <span className="logout-btn__label">Log Out</span>
      </button>

      <ConfirmModal
        open={showLogoutConfirm}
        title="Log out?"
        description="You are about to log out of your dashboard. Any unsaved changes on the current page may be lost. Do you want to continue?"
        onCancel={handleCancelLogout}
        onConfirm={handleConfirmLogout}
        confirmText="Log out"
        cancelText="Stay logged in"
        confirmButtonVariant="danger"
      />
    </header>
  );
};

/** React component — Dashboard Header. */
export default DashboardHeader;
